import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Banner/Banner.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/client/AuthProviderClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/client/CookieProviderClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/client/NavbarShell.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/client/ToastifyClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Footer/Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["FilterProvider"] */ "/vercel/path0/src/context/FilterContext.js");
